// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import {
  ApolloClient,
  createHttpLink,
  InMemoryCache,
  concat,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";

import { getToken } from "../services/firebase";

const authMiddleware = setContext(async (_, { headers }) => {
  const token = await getToken();

  return {
    headers: {
      ...headers,
      Authorization: token ? `Bearer ${token}` : "",
    },
  };
});

function createClient() {
  return new ApolloClient({
    link: concat(
      authMiddleware,
      createHttpLink({
        uri: process.env.REACT_APP_API_URL,
      })
    ),
    cache: new InMemoryCache(),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: "no-cache",
      },
      query: {
        fetchPolicy: "no-cache",
      },
    },
  });
}

const graphql = {
  createClient,
};

export default graphql;
